<template>
  <v-dialog
    :value="show"
    max-width="540px"
    persistent
    content-class="ma-3 ma-md-6"
  >
    <v-card class="card-alert">
      <v-toolbar color="secondary" dark text>
        <v-toolbar-title class="card-alert-header">
          {{ cardTitle }}
        </v-toolbar-title>

        <v-spacer />

        <v-btn icon @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" class="card-alert-text pt-10">
        {{ message }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters justify="center">
          <v-col cols="10" md="4" sm="6">
            <v-btn
              color="primary"
              block
              class="card-alert-button1"
              @click="close"
            >
            Ok
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  computed: {
    cardTitle() {
      if(this.error && !this.isMessage){
        return "Error";
      } else if(!this.error && !this.isMessage){
        return "Exito";
      } else {
        return "Mensaje";
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: null,
    },
    error: {
      type: Boolean,
      default: false,
    },
    redirect: {
      type: String,
      default: 'no'
    },
    scrollUp: {
      type: Boolean,
      default: false
    },
    isMessage: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false);
      if (this.redirect === 'yes' && !this.error) {
        this.$router.push({ name: 'login' })
      }

      if(this.scrollUp){
        window.scrollTo({ top: 0, behavior:'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/alerts/styles";
</style>
